<template>
  <div class="job-card">
    <div
      class="jobs d-flex"
      style="justify-content: space-between;"
      @click="$emit('click', job)"
    >
      <div class="details-container">
        <div class="company-name">{{ company }}</div>
        <div class="job-title" v-html="highlightText(job.job_title, 'job_title')"></div>
      </div>
      <div v-if="isJobScouted" class="scouted-badge">
        <div class="scouted-badge-text">スカウト<br />希望済</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "JobListItem",
  props: {
    job: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    isJobScouted: {
      type: Boolean,
      required: true,
    },
    company: {
      type: String,
      required: true,
    },
    searchHighlights: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    highlightText(text, field) {
      if (!text || !this.searchHighlights.length) return text;
      
      const fieldHighlights = this.searchHighlights.find(h => h.path === field);
      if (!fieldHighlights || !fieldHighlights.texts) return text;

      // Get hits and sort by length (longest first)
      const hits = fieldHighlights.texts
        .filter(text => text.type === 'hit')
        .map(text => text.value)
        .sort((a, b) => b.length - a.length);

      if (!hits.length) return text;

      // First handle full-width spaces between hits
      let highlightedText = this.highlightFullWidthSpaces(text, hits);
      // Then highlight the hits
      console.log(highlightedText);
      return this.highlightHits(highlightedText, hits);
    },

    highlightFullWidthSpaces(text, hits) {
      // Create patterns for all possible hit combinations with full-width space
      const patterns = hits.flatMap((hit1, index) =>
        hits.slice(index + 1).map((hit2) => ({
          pattern: new RegExp(
            `(${this.escapeRegExp(hit1)}　${this.escapeRegExp(hit2)})|(${this.escapeRegExp(hit2)}　${this.escapeRegExp(hit1)})`,
            'g'
          ),
          replacement: (_, g1, g2) => {
            const match = g1 || g2;
            const [first, second] = match.split('　');
            return `${first}<span class="highlight">　</span>${second}`;
          },
        }))
      );

      // Apply all patterns at once
      return patterns.reduce(
        (text, { pattern, replacement }) => text.replace(pattern, replacement),
        text
      );
    },

    highlightHits(text, hits) {
      const highlightedPositions = new Set();

      return hits.reduce((text, hit) => {
        const pattern = new RegExp(this.escapeRegExp(hit), 'g');
        return text.replace(pattern, (match, offset) => {
          const positions = Array.from(
            { length: match.length },
            (_, i) => offset + i
          );

          if (positions.every((pos) => !highlightedPositions.has(pos))) {
            positions.forEach((pos) => highlightedPositions.add(pos));
            return `<span class="highlight">${match}</span>`;
          }
          return match;
        });
      }, text);
    },

    escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }
  }
};
</script>

<style scoped>
.job-card {
  background-color: white;
  border: 1px solid #e0e0e0;
  border-radius: 1px;
  padding: 16px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;
}

.job-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.details-container {
  width: 285px; /* Default width for mobile */
}

.company-name {
  font-weight: bold;
  font-size: 16px;
  color: #3c3c3c;
  font-weight: 600;
  margin-bottom: 8px;
}

.job-title {
  font-size: 14px;
  font-weight: 600;
  color: #3c3c3c;
  word-wrap: break-word;
  white-space: normal;
}

.scouted-badge {
  margin: auto 0px;
}

.scouted-badge-text {
  width: 60px;
  border: 1px solid #f6ae2d;
  color: #f6ae2d;
  text-align: center;
  font-size: 10px;
}

.job-description {
  font-size: 12px;
  color: #666;
  margin-top: 4px;
  word-wrap: break-word;
  white-space: normal;
}

>>> .highlight {
  background-color: #ffd700;
  padding: 0 2px;
  border-radius: 2px;
}

@media (min-width: 1024px) {
  .details-container {
    width: 700px;
  }
}
</style>
